import React, {useState, useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Pagination } from '@vds/pagination';
import {
    Flex,
    GridWrapper,
    TileWrapper,
    ImageWrapper,
    Image,
    Block,
    MOBILE_BREAKPOINT,
    TABLET_BREAKPOINT,
} from '../../../../components/common/StyledComponent/CommonStyledComponent.jsx';
import {
    AskAICtaPrimaryButton,
    ModalCard,
    ModalCloseButton,
    ModalOverlay,
} from '../../AskAIPageStyles.jsx';
import { ButtonIcon } from '@vds/button-icons';
// import Favorite from '../../Common/favroite.jsx';
import { Icon } from '@vds/icons';
import './searchResults.scss';
import AiTopics from '../AI-Topics/aiTopics.jsx';
import NullScreenResults from '../Null-Results/nullScreenResults.jsx';
import CalendarViewCardComponent from '../../../../components/common/CalendarViewCards/CalendarViewCards.jsx';
import AiMobileSearchCard from '../AI-Calendar/aiCalendarView.jsx';
import { getInfoHubHtml, classicSearchResults } from '../../../../utility/common.js';
import DOMPurify from 'dompurify';
import { Helmet } from 'react-helmet';
import { Grid } from '@vds/grids';
import { Col, Row } from '@vds-core/grids';
import { cloneDeep } from "lodash";
import SearchResultItemCard from './SearchResultItemCard.jsx';
import {searchFilter, viewSearchResults, contentClick} from '../../../../common/Analytics/GAWrapper.jsx';
import { Loader } from '@vds/loaders';
import { findCourseById, getSuggestionData, formatEventDate} from "../../../../utility/utils.js";


// const mockResults = [
//     { id: 1, type: 'Course', provider: 'Standard Course', title: 'Intro to online growth marketing: From customer to advocate', duration: '29 minutes', recommended: true, thumbnail: 'data:image/jpeg;base64,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' },
//     { id: 2, type: 'Course', provider: 'Standard Course', title: 'Paid advertising: What to consider before purchasing', duration: '26 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: 3, type: 'Course', provider: 'Standard Course', title: 'Digital tools for financial readiness', duration: '25 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '4', type: 'Virtual event', provider: 'Hands-on Help', title: 'Deck strategy & development', duration: 'Jul 6, 12:30 PM ET', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '5', type: 'Course', provider: 'Standard Course', title: 'Level up your goal setting with objectives and key results', duration: '29 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '6', type: 'Quick tip', provider: 'Video', title: 'Drive traffic to your website with SEO', duration: '5 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '7', type: 'Course', provider: 'Standard Course', title: 'Money mindset: Removing blockers', duration: '10 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '8', type: 'Course', provider: 'Standard Course', title: 'Recruiting, onboarding, and retaining the talent you need', duration: '18 minutes', recommended: true, thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVRxzg0U67_vDuHHzYxZiXC2Uqfy4yubmalOsuvi3DtgDkAfNGBbsQ1tY&s' },
//     { id: '9', type: 'Course', provider: 'Standard Course', title: 'Getting the most from investing in mentorship', duration: '10 minutes', recommended: true, thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVRxzg0U67_vDuHHzYxZiXC2Uqfy4yubmalOsuvi3DtgDkAfNGBbsQ1tY&s' },
//     { id: '10', type: 'Course', provider: 'Standard Course', title: 'Intro to online growth marketing: From customer to advocate', duration: '29 minutes', recommended: true, thumbnail: 'data:image/jpeg;base64,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' },
//     { id: '11', type: 'Course', provider: 'Standard Course', title: 'Paid advertising: What to consider before purchasing', duration: '26 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '12', type: 'Course', provider: 'Standard Course', title: 'Digital tools for financial readiness', duration: '25 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '13', type: 'Virtual event', provider: 'Hands-on Help', title: 'Deck strategy & development', duration: 'Jul 6, 12:30 PM ET', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '14', type: 'Course', provider: 'Standard Course', title: 'Level up your goal setting with objectives and key results', duration: '29 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '15', type: 'Quick tip', provider: 'Video', title: 'Drive traffic to your website with SEO', duration: '5 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '16', type: 'Course', provider: 'Standard Course', title: 'Money mindset: Removing blockers', duration: '10 minutes', recommended: true, thumbnail: 'https://images.unsplash.com/photo-1507206130118-b5907f817163?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29ycG9yYXRlJTIwd29tYW58ZW58MHx8MHx8fDA%3D' },
//     { id: '17', type: 'Course', provider: 'Standard Course', title: 'Recruiting, onboarding, and retaining the talent you need', duration: '18 minutes', recommended: true, thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVRxzg0U67_vDuHHzYxZiXC2Uqfy4yubmalOsuvi3DtgDkAfNGBbsQ1tY&s' },
//     { id: '18', type: 'Course', provider: 'Standard Course', title: 'Getting the most from investing in mentorship', duration: '10 minutes', recommended: true, thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVRxzg0U67_vDuHHzYxZiXC2Uqfy4yubmalOsuvi3DtgDkAfNGBbsQ1tY&s' },
// ];

// const filters = ['All', 'Courses', 'Virtual events', 'In-person events', 'Quick tips', 'Learning paths'];

const SEARCH_TOGGLE_SWITCH_DELAY = 380;

const SearchResultsComponent = ({ query, onToggleAskAI = null, initialFilter = 'all' }) => {
    const pillToModalType = {
        'courses': 'Course',
        'inpersonevents': 'In-Person Events',
        'virtualevents': 'Event',
        'learningpaths': 'Learning Path',
        'quicktips': 'Quick Tip'
        };

    const modalTypeToPill = {
        'Course': 'courses',
        'In-Person Events': 'inpersonevents',
        'Event': 'virtualevents',
        'Learning Path': 'learningpaths',
        'Quick Tip': 'quicktips'
    };
    console.log('SearchResultsComponent rendered with query:', query);
       const [fetchedResults, setfetchedResults] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [inputValue, setInputValue] = useState(query || '');
    let lng = localStorage.getItem('lng') ? localStorage.getItem('lng') : 'en';
    // const [activeFilter, setActiveFilter] = useState('All');
    const [isAskAiEnabled, setIsAskAiEnabled] = useState(false);
    const [showSortModal, setShowSortModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    // const [selectedPage, setSelectedPage] = useState(2);
    const [searchQuery, setSearchQuery] = useState(query);
    const inputRef = React.useRef(null);
    const [expandedSections, setExpandedSections] = useState({ type: true, topic: true, skilllevel: true });
    const askAiData = useSelector((state) => state.Aem?.aemAiSearchData);
    const filterPills = askAiData?.resultsPageTexts?.classicSearchTexts?.filterPills || [];
    console.log('filterPills:', filterPills);
    const sortbyData = askAiData?.resultsPageTexts?.classicSearchTexts?.sortbyData;
    const toggleTextsData = askAiData?.resultsPageTexts?.toggleData;
    const isMobile = useSelector((state) => state.MediaType?.isMobile);
    // const [searchResults, setSearchResults] = useState([]);
    // const [apiTotalCount, setApiTotalCount] = useState(0);
    const [mainSearchResults, setMainSearchResults] = useState([]); 
    const [resetPagination, setResetPagination] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentQueryNew, setCurrentQueryNew] = useState(query || '');
    const getToggleLabel = (key) => {
    const item = toggleTextsData?.find((t) => t.key === key);
        return item?.toggleLbl ?? '';
    };

    const [activeFilters, setActiveFilters] = useState([initialFilter]);
    const [sortType, setSortType] = useState('best-match');
    const [tempSortType, setTempSortType] = useState('best-match');
    const courseCxAemData = useSelector((state) => state?.Aem?.courseCxJsonData);
    const filterModalDlts = askAiData?.resultsPageTexts?.classicSearchTexts?.cscFilterDlts || [];
    const [modalFilters, setModalFilters] = useState({ type: [], topic: [], skill: [] });
    const [appliedModalFilters, setAppliedModalFilters] = useState({ type: [], topic: [], skill: [] });
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const askAiSwitchTimerRef = useRef(null);

    const newSuggestionsData = getSuggestionData();
    const ai_searchJsonData = JSON.parse(localStorage.getItem('aisearch_landingpage_data')) || {};
    const ai_suggestionData = newSuggestionsData || JSON.parse(localStorage.getItem('aisearch_suggestions_data'))?.data || {};

    const handleSwitchToAskAI = () => {
        if (askAiSwitchTimerRef.current) {
            clearTimeout(askAiSwitchTimerRef.current);
        }

        setIsAskAiEnabled(true);

        if (typeof onToggleAskAI === 'function') {
            askAiSwitchTimerRef.current = setTimeout(() => {
                onToggleAskAI();
            }, SEARCH_TOGGLE_SWITCH_DELAY);
            return;
        }

        setIsAskAiEnabled((prev) => !prev);
    };

    useEffect(() => {
        if (showSortModal) {
        setTempSortType(sortType);
        }
    }, [showSortModal, sortType]);

    useEffect(() => {
        return () => {
            if (askAiSwitchTimerRef.current) {
                clearTimeout(askAiSwitchTimerRef.current);
            }
        };
    }, []);

    // Helper to determine the pill category for a given item based on its raw data
    const getItemCategoryKey = (item) => {
        const type = (item.type || '').toLowerCase();
        const format = (item.format || '').toLowerCase();
        const moduleFormat = (item.moduleFormat || '').toLowerCase();
        const topics = Array.isArray(item.topics) ? item.topics.map(t => t.toLowerCase()) : [];
        console.log('getItemCategoryKey called with item:', item);
        if (format === 'quick tip') return 'quicktips';
        if (type === 'learningprogram') return 'learningpaths';
        if (type === 'course'){
        if(format === 'blended') return 'virtualevents';
        if(format === 'classroom') return 'inpersonevents';
        if (topics.includes('recorded event')) return 'virtualevents';
        return 'courses';
        } 

        return 'all';
    };

    // const handleToggle = () => {
    //     const firstQuery = localStorage.getItem('firstQuery');
    //     const queryString = firstQuery ? `?q=${encodeURIComponent(firstQuery)}` : '';
    //     setIsAskAiEnabled((prev) => {
    //         const next = !prev;
    //         const activeKey = next ? 'askai' : 'search';
    //         console.log('Toggle status:', getToggleLabel(activeKey));
    //         if (activeKey === 'search') {
    //             window.location.href = `/classic-search${queryString}`;
    //         } else if (activeKey === 'askai') {
    //             window.location.href = `/askai${queryString}`;
    //         }
    //         return next;
    //     });
    // };
    // const isTablet = useSelector((state) => state.MediaType?.isTablet);
    const isTablet =
        window.innerWidth > MOBILE_BREAKPOINT &&
        window.innerWidth <= TABLET_BREAKPOINT;
    const [htmlEventsData, setHtmlEventsData] = useState(null);

    const PAGE_SIZE = (isMobile || isTablet) ? 12 : 18;
    
    const toggleSection = (section) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const urlQuery = params.get('q');
        if (urlQuery) {
            localStorage.setItem('firstQuery', decodeURIComponent(urlQuery));
        }
    }, []);

    useEffect(() => {
        // const aemURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/ai/search-ai/master.html`;
        const aemURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/ai/search-ai/master.html`;
        getInfoHubHtml(aemURL)
            .then((response) => {
                console.log(' AEM HTML data fetched successfully:', global.config, response);
                setHtmlEventsData(response?.data)
            });
    }, [lng]);
    useEffect(() => {
        const originalHtmlOverflow = document.documentElement.style.overflow;
        const originalBodyOverflow = document.body.style.overflow;

        if (showSortModal || showFilterModal) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.documentElement.style.overflow = originalHtmlOverflow;
            document.body.style.overflow = originalBodyOverflow;
        };
    }, [showSortModal, showFilterModal]);

    useEffect(() => {
    if (resetPagination) {
      setCurrentPage(1);
    }
  }, [resetPagination]);
useEffect(() => {
    if (isFilterApplied) { 
      searchFilter('AskAI-Classic Search', '', '', modalFilters?.skill?.filter(s => s !== 'View all').join(','), '', modalFilters?.type?.map(t=>t==='Event'?'Virtual events':t).join(','), '', filteredAndSortedResults.length);
    viewSearchResults(currentQueryNew ? currentQueryNew : '', 'Regular Search', filteredAndSortedResults.length, 'Classic search');
      setIsFilterApplied(false);
     }
  }, [isFilterApplied]);
  const handlePagination = (page) => {
     window.scrollTo(0, 0);
    // let clonedData = cloneDeep(mainSearchResults);
    // setSearchResults(clonedData.splice((page - 1) * PAGE_SIZE, PAGE_SIZE));
    setResetPagination(false);
    setCurrentPage(page);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (query) {
      handleSearch();
    } else {
      setIsLoading(false); 
    }
  }, []);

    const handleSearch = async () => {
         setIsLoading(true);
        const currentQuery = inputRef.current?.value?.trim();
        setCurrentQueryNew(currentQuery);
        if (!currentQuery) return;
        //  contentClick(
        //   currentQuery,
        //   window.location.href,
        //   "", 
        //   'classic_search_button',
        // );
        try {
            const response = await classicSearchResults({
              query: currentQuery,
              source: "SBDR",
              // pageSize : 100,
              pageNumber: 1,
            });
            console.log('Search API response:', response);
            const fetchedResults = response.results || (Array.isArray(response) ? response : [response]);
            setfetchedResults(fetchedResults);
            const excludedTypes = ['page', 'instructor', 'spotlight', 'gated', 'nongated', 'grantstories', 'grants'];
            const seenTitles = new Set();
            const seenIds = new Set();
            
            const filteredResults = fetchedResults.filter((item) => {
                 if ((!item?.title || item.title.trim() === '') && item?.type !== 'unstructured') {
                console.log("Excluding item due to missing title:", item);
                return false;
              }
              if (item?.launchUrl && typeof item.launchUrl === 'string' && item.launchUrl.includes('/es/')) {
                console.log("Excluding item due to Spanish launchUrl (/es/):", item);
                return false;
              }
              if (item?.localizeData && item.localizeData.locale === 'es-ES') {
                console.log("Excluding item due to Spanish localizeData (es-ES):", item);
                return false;
              }
                if (item?.type === 'unstructured' && item?.launchUrl) {
                    console.log("classic unstructured item launchUrl:", item.launchUrl);
                    const match = item.launchUrl.match(/course_(\d+)/i);
                    if (match && match[1]) {
                    item.id = `course:${match[1]}`;
                    console.log("classic unstructured item launchUrl item.id:", item.id);
                    }
                }
                if (!item.id) {
                    return false;
                }
                if (seenIds.has(item.id)) {
                    return false;
                }
              if (!item.type && !item.format) {
                  return false;
              }
              if (item?.type === 'unstructured') {
                const courseData = findCourseById(item.id, ai_suggestionData, item, ai_searchJsonData);
                if (!courseData || !courseData.resource) {
                  return false; 
                }
              }
                const itemType = (item.type || '').toLowerCase();
                const itemTitle = (item.title || '').trim().toLowerCase();

                if (excludedTypes.includes(itemType)) return false;

                if (seenTitles.has(itemTitle)) return false;

                seenTitles.add(itemTitle);
                 seenIds.add(item.id);
                return true;
              });

            const count = response.totalCount 
            ? response.totalCount - (fetchedResults.length - filteredResults.length) 
            : filteredResults.length;
            console.log('Fetched results:', fetchedResults);
            console.log('filteredResults results:', filteredResults);
            console.log('Total count:', count);
           
            // Map the API data to match the card structure
            const mappedResults = filteredResults.map((item, index) => {
                // --- ADDED: Get course properties for unstructured items and merge ---
              let currentItem = { ...item };
              if (currentItem?.type === 'unstructured' && currentItem?.id) {
                const courseData = findCourseById(currentItem.id, ai_suggestionData, currentItem, ai_searchJsonData);
                console.log('^^courseDataSource', courseData);
                
                if (courseData && courseData?.resource) {
                  currentItem = {
                    ...currentItem,
                    ...courseData?.resource,
                    // Force the correct type so categories resolve properly
                    type: courseData?.resource?.type || courseData?.resourceType || 'course',
                    publishedDate: courseData?.resource?.datePublished || currentItem.publishedDate
                  };
                }
                currentItem.launchUrl = '/course-details/' + currentItem.id;
                currentItem.topics = courseData?.resource?.tags ||  [];
              }
              // ---------------------------------------------------------------------
              console.log('Mapping item:', currentItem);

              const itemType = (currentItem.type || '').toLowerCase();
              const itemFormat = (currentItem.format || '').toLowerCase();
              const isQuickTip = (itemFormat  || '').toLowerCase() === 'quick tip';
              let durationMinutes = isQuickTip ? currentItem.qtdt : `${Math.round(currentItem?.duration / 60)} minutes`;
              const hasRecordedEventTopic = Array.isArray(currentItem) && currentItem.topics.some(t => t.toLowerCase() === 'recorded event');
              const isEvent = itemType.includes('course') && (itemFormat === 'blended' || itemFormat === 'classroom' || hasRecordedEventTopic);              
              const sortDate = isEvent ? (currentItem.startDate || currentItem.publishedDate) : (currentItem.publishedDate || currentItem.startDate);
              
               //--------------------------------learning path duration logic---------------------------------------------//
              if (itemType.includes('learningprogram') || itemType === "learningprogram") {
                const selectedLp = ai_suggestionData?.learningProgram?.[currentItem?.id];
                console.log('Selected Learning Path:', selectedLp);
                console.log('List of LP Contents:', selectedLp?.listOfResources?.[0]?.loIds);
                const listOfLPContents = selectedLp?.listOfResources?.[0]?.loIds || [];
                
                const uniqueLoIds = listOfLPContents.filter((item, pos) => listOfLPContents.indexOf(item) === pos);
                
                let totalDurationSeconds = 0;

                uniqueLoIds.forEach((loId) => {
                   const resource = ai_suggestionData?.courses?.[loId] || ai_suggestionData?.events?.[loId];
                   if (resource && resource.duration) {
                       totalDurationSeconds += resource.duration;
                   }
                });
                
                const totalMinutes = Math.ceil(totalDurationSeconds / 60);
                console.log('Total duration for Learning Path (in minutes):', totalMinutes);
                if (totalMinutes > 0) {
                   durationMinutes = `${totalMinutes} minutes`;
                   console.log('Updated duration for Learning Path:', durationMinutes); 
                }
              }
              //---------------------------------------------------------------------------------------------------------//

              return {
              id: currentItem.id,
              type: currentItem.type,
              format: currentItem.format,
              title: currentItem.title,
              // Convert duration from seconds to minutes
              duration: durationMinutes,
              recommended: false, 
              thumbnail: currentItem.imageUrl,
              launchUrl : currentItem.launchUrl,
              topics: currentItem.topics || [],
              moduleFormat: currentItem.moduleFormat,
              isInPersonEvent: currentItem?.isInPersonEvent ? currentItem?.isInPersonEvent : '',
              originalIndex: index,       
              date: sortDate,  
              skillLevel: Array.isArray(currentItem.skills) ? currentItem.skills.map(skill => `${skill.name}:${skill.level}`) : [],         
              };
            });
            console.log('Mapped results:', mappedResults);
             // Verify if the requested initialFilter actually has results
            const availableCategories = new Set(mappedResults.map(getItemCategoryKey));
            
            if (initialFilter !== 'all' && !availableCategories.has(initialFilter)) {
              setActiveFilters(['all']);
            } else {
              // Otherwise apply the requested filter
              setActiveFilters([initialFilter]);
            }
            setAppliedModalFilters({ type: [], topic: [], skill: [] });
            setModalFilters({ type: [], topic: [], skill: [] });
            setMainSearchResults(mappedResults);
            // setApiTotalCount(count);
            // let clonedData = cloneDeep(mappedResults);
            // setSearchResults(clonedData.splice(0, PAGE_SIZE));
            setResetPagination(true);
            try {
              viewSearchResults(currentQuery ? currentQuery : '', 'Regular Search', count, 'Classic search');
            } catch (e) {
              console.warn('viewSearchResults error:', e);
            }
        } catch (error) {
            console.error('Search API error:', error);
        } finally {
          setIsLoading(false);
        }
    };

    //1. Calculate which categories actually exist in the current search results
  const availableCategories = useMemo(() => {
    return new Set(mainSearchResults.map(getItemCategoryKey));
  }, [mainSearchResults]);
    console.log('Available categories:', availableCategories);
  
 // 2. Hide specific pills if they have 0 results
  const visibleFilters = useMemo(() => {
    return filterPills.filter(pill => pill.key === 'all' || availableCategories.has(pill.key))
  }, [availableCategories, filterPills]);
    console.log('Visible filters:', visibleFilters);
  
    // 3. Filter the results down based on active selections
  const filteredMainResults = useMemo(() => {
     let results = mainSearchResults;    

    // 1. Pill Header Active Filters
    if (!activeFilters.includes('all')) {
      results = results.filter(item => activeFilters.includes(getItemCategoryKey(item)));
    }

    // 2. Modal Type Filter
    if (appliedModalFilters.type.length > 0 && !appliedModalFilters.type.includes('View all')) {
      results = results.filter(item => {
        const typeKey = getItemCategoryKey(item);
        const allowedPillKeys = appliedModalFilters.type.map(v => {
          if (v === 'Course') return 'courses';
          if (v === 'In-Person Events') return 'inpersonevents';
          if (v === 'Event') return 'virtualevents';
          if (v === 'Learning Path') return 'learningpaths';
          if (v === 'Quick Tip') return 'quicktips';
          return '';
        });
        return allowedPillKeys.includes(typeKey);
      });
    }

    // 3. Modal Topic Filter
    if (appliedModalFilters.topic.length > 0 && !appliedModalFilters.topic.includes('View all')) {
      results = results.filter(item => {
        const itemNormalizedTopics = item.topics.map(t => t.toLowerCase().split(' ').join(''));
        return itemNormalizedTopics.some(t => appliedModalFilters.topic.includes(t));
      });
    }

    // 4. Modal Skill Level Filter
    if (appliedModalFilters.skill.length > 0 && !appliedModalFilters.skill.includes('View all')) {
       results = results.filter(item => {
        if (Array.isArray(item.skillLevel) && item.skillLevel.length > 0) {
            return item.skillLevel.some(skillKey => appliedModalFilters.skill.includes(skillKey));
        }
        return appliedModalFilters.skill.includes(item.skillLevel);
        });
    }

    return results;
  }, [mainSearchResults, activeFilters, appliedModalFilters]);

//   // 4. Update the pagination array and total count ONLY from filtered data
//   useEffect(() => {
//     console.log('Filtered results:', filteredMainResults);
//     setApiTotalCount(filteredMainResults.length);
//     let clonedData = cloneDeep(filteredMainResults);
//     setSearchResults(clonedData.splice((currentPage - 1) * PAGE_SIZE, PAGE_SIZE));
//   }, [filteredMainResults, currentPage, PAGE_SIZE]);

  const handleFilterClick = (clickedFilter) => {
    let newFilters = activeFilters.filter(f => f !== 'all');
    console.log('Clicked filter:', clickedFilter);
    if (clickedFilter === 'all') {
      newFilters = ['all'];
    } else {
      if (newFilters.includes(clickedFilter)) {
        // Deselect if already selected
        newFilters = newFilters.filter(f => f !== clickedFilter);
      } else {
        // Select specific pill
        newFilters.push(clickedFilter);
      }

      // If all specific pills are deselected, revert back to "All"
      const availablePillKeys = visibleFilters.map(f => f.key).filter(k => k !== 'all');
      const areAllAvailablePillsSelected = availablePillKeys.length > 0 && availablePillKeys.every(key => newFilters.includes(key));

      if (areAllAvailablePillsSelected || newFilters.length === 0) {
        newFilters = ['all'];
      }
    }
    setActiveFilters(newFilters);
    // Sync the Modal Checkboxes to match the new Pill selection
    const allTypes = filterModalDlts.find(s => s.category === 'Type')?.subCategory[0].options.map(o => o.value) || [];
    let syncedModalTypes = [];

    if (newFilters.includes('all')) {
      syncedModalTypes = allTypes;
    } else {
      syncedModalTypes = newFilters.map(f => pillToModalType[f]).filter(Boolean);
      // If the user manually clicked every pill, auto-check "View all"
      const typeOptionsOnly = allTypes.filter(t => t !== 'View all');
      if (syncedModalTypes.length === typeOptionsOnly.length) {
        syncedModalTypes.push('View all');
        setActiveFilters(['all']); // revert activeFilters to 'all' to stay clean
      }
    }
    setAppliedModalFilters(prev => ({ ...prev, type: syncedModalTypes }));
    setModalFilters(prev => ({ ...prev, type: syncedModalTypes }));
    // Reset back to page 1
    setResetPagination(true);
    setCurrentPage(1);
    setIsFilterApplied(true);
  };

    // 3.Sort the results by best match and date
    const filteredAndSortedResults = useMemo(() => {
        let results = [...filteredMainResults];

    if (sortType === 'date') {
      results.sort((a, b) => new Date(a.date) - new Date(b.date));
    } 
    console.log('Filtered and sorted results:', results);
    return results;
  }, [filteredMainResults, sortType]);

      // 4. Update the pagination array and total count ONLY from filtered data
    //  useEffect(() => {
    //     console.log('Filtered results:', filteredMainResults);
    //     setApiTotalCount(filteredAndSortedResults.length);
    //     let clonedData = cloneDeep(filteredAndSortedResults);
    //     setSearchResults(clonedData.splice((currentPage - 1) * PAGE_SIZE, PAGE_SIZE));
    // }, [filteredAndSortedResults, currentPage, PAGE_SIZE]);

    const apiTotalCount = filteredAndSortedResults.length;
    const searchResults = useMemo(() => {
        let clonedData = cloneDeep(filteredAndSortedResults);
        return clonedData.splice((currentPage - 1) * PAGE_SIZE, PAGE_SIZE);
    }, [filteredAndSortedResults, currentPage, PAGE_SIZE]);

    const uniqueTopics = Array.from(new Set(mainSearchResults.flatMap(item => item.topics)));

    const aemTopicsArray = Array.isArray(courseCxAemData) 
        ? courseCxAemData 
        : courseCxAemData?.allTopics?.allTopicsData || [];
    // const allTopicsObj = {};
    // aemTopicsArray.forEach((item) => {
    //     if (item?.value) {
    //         const normalizedKey = item.value.toLowerCase().split(' ').join('');
    //         allTopicsObj[normalizedKey] = item;
    //     }
    // });

    // 2. Filter API topics and apply the mapping logic
    const seenTopicIds = new Set();
    const renderableTopics = aemTopicsArray.reduce((acc, topicData) => {
        if (topicData?.value) {
            const normalizedTag = topicData.value.toLowerCase().split(' ').join('');
             // Prevent duplicates
            if (!seenTopicIds.has(normalizedTag)) {
                seenTopicIds.add(normalizedTag);
                
                const isNonClickable = topicData?.noResultsPage === 'true';
                let lng = localStorage.getItem("lng") || 'en';
                // Build the URL applying the /results/ routing logic
                const basePath = lng === 'en' ? `/results/` : `/es/results/`;
                const redirectUrl = `${basePath}${normalizedTag}`;
                
                acc.push({
                    id: normalizedTag,
                    title: topicData?.label || topicData.value, // Fallback to value if label is missing
                    icon: topicData?.aiImgUrl || 'custom-audience', 
                    imageUrl: topicData?.aiImgUrl || '', 
                    isNonClickable: isNonClickable,
                    redirectUrl: redirectUrl
                });
            }
        }
        return acc;
    }, []);
console.log("renderableTopics", renderableTopics);

// Sync modal view state with applied state when opened
  useEffect(() => {
    if (showFilterModal) {
      setModalFilters(appliedModalFilters);
    }
  }, [showFilterModal, appliedModalFilters]);

  useEffect(() => {
    if (showSortModal) {
      setTimeout(() => document.getElementById('sort-close-btn')?.focus(), 50);
    }
  }, [showSortModal]);

  useEffect(() => {
    if (showFilterModal) {
      setTimeout(() => document.getElementById('filter-close-btn')?.focus(), 50);
    }
  }, [showFilterModal]);

  // 3. Focus Trap and Escape Key Listener
 useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (showSortModal) handleCloseSortModal();
        if (showFilterModal) handleCloseFilterModal();
      }

      if (e.key === 'Tab') {
        const activeModalId = showSortModal ? 'sort-modal-card' : showFilterModal ? 'filter-modal-card' : null;
        if (activeModalId) {
          const modal = document.getElementById(activeModalId);
          if (modal) {
            const focusableElements = modal.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (focusableElements.length > 0) {
              const firstElement = focusableElements[0];
              const lastElement = focusableElements[focusableElements.length - 1];

              // [A11Y_FIX] If focus is lost to background, force it to the first element
              if (!modal.contains(document.activeElement)) {
                e.preventDefault();
                firstElement.focus();
                return;
              }

              if (e.shiftKey) { // Shift + Tab
                if (document.activeElement === firstElement) {
                  e.preventDefault();
                  lastElement.focus();
                }
              } else { // Tab
                if (document.activeElement === lastElement) {
                  e.preventDefault();
                  firstElement.focus();
                }
              }
            }
          }
        }
      }
    };

    if (showSortModal || showFilterModal) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showSortModal, showFilterModal]);


  // Handle modal checkbox updates dynamically
  const handleCheckboxChange = (category, value, checked) => {
      setModalFilters((prev) => {
          let current = [...prev[category]];

          if (value === 'View all') {
              if (checked) {
                  // Select everything for this category
                  if (category === 'type') current = filterModalDlts.find(s => s.category === 'Type')?.subCategory[0].options.map(o => o.value) || [];
                  if (category === 'topic') current = ['View all', ...renderableTopics.map(t => t.id)];
                  if (category === 'skill') current = filterModalDlts.find(s => s.category === 'Skill level')?.details.filter(o => o.skillName !== 'All').map(o => o.key) || [];
              } else {
                  current = [];
              }
          } else {
              if (checked) {
                  current.push(value);
                  // Verify if everything is selected to automatically check "View all"
                  let allPossible = [];
                  if (category === 'type') allPossible = filterModalDlts.find(s => s.category === 'Type')?.subCategory[0].options.filter(o => o.value !== 'View all').map(o => o.value) || [];
                  if (category === 'topic') allPossible = renderableTopics.map(t => t.id);
                  if (category === 'skill') allPossible = filterModalDlts.find(s => s.category === 'Skill level')?.details.filter(o => o.skillName !== 'All' && o.key !== 'View all').map(o => o.key) || [];

                  const allChecked = allPossible.every(val => current.includes(val));
                  if (allChecked && !current.includes('View all')) {
                      current.push('View all');
                  }
              } else {
                  current = current.filter(v => v !== value && v !== 'View all');
              }
          }
          return { ...prev, [category]: current };
      });
  };

  const handleApplyModalFilters = () => {
     const finalFilters = {
          type: modalFilters.type.length === 0 ? ['View all'] : modalFilters.type,
          topic: modalFilters.topic.length === 0 ? ['View all'] : modalFilters.topic,
          skill: modalFilters.skill.length === 0 ? ['View all'] : modalFilters.skill
      };
      setAppliedModalFilters(finalFilters);
      setModalFilters(finalFilters);
      setShowFilterModal(false);
      setResetPagination(true);
      setIsFilterApplied(true);
      setCurrentPage(1);
      console.log('modalFilters',finalFilters);

       setTimeout(() => { document.querySelector('[aria-label="Filter"]')?.focus(); }, 10);
      // Sync the Pills to match the newly applied Modal types
      if (modalFilters.type.includes('View all') || modalFilters.type.length === 0) {
          setActiveFilters(['all']);
      } else {
          const newActivePills = modalFilters.type.map(t => modalTypeToPill[t]).filter(Boolean);
          setActiveFilters(newActivePills.length > 0 ? newActivePills : ['all']);
      }
  };

  const handleClearAllFilters = () => {
      setModalFilters({ type: [], topic: [], skill: [] });
  };

  const handleCloseSortModal = () => {
    setShowSortModal(false);
    setTimeout(() => { document.querySelector('[aria-label="Sort"]')?.focus(); }, 10);
  };

  const handleCloseFilterModal = () => {
    const isClearedAll = modalFilters.type.length === 0 && 
                         modalFilters.topic.length === 0 && 
                         modalFilters.skill.length === 0;

    if (isClearedAll) {
      setAppliedModalFilters({ type: [], topic: [], skill: [] });
      setActiveFilters([]);
      setResetPagination(true);
      setCurrentPage(1);
    } else {
      setModalFilters(appliedModalFilters);
    }

    setShowFilterModal(false);
     setTimeout(() => { document.querySelector('[aria-label="Filter"]')?.focus(); }, 10);
  };
  useEffect(() => {
    if (filterModalDlts.length > 0) {
        const allTypes = filterModalDlts.find(s => s.category === 'Type')?.subCategory[0].options.map(o => o.value) || [];
        const allTopics = ['View all', ...renderableTopics.map(t => t.id)];
        const allSkills = filterModalDlts.find(s => s.category === 'Skill level')?.details.filter(o => o.skillName !== 'All').map(o => o.key) || [];

         // Respect any pre-selected activeFilters (pills)
        let initialTypes = allTypes;
        if (!activeFilters.includes('all')) {
            initialTypes = activeFilters.map(f => pillToModalType[f]).filter(Boolean);
        }
        setModalFilters({ type: allTypes, topic: allTopics, skill: allSkills });
        setAppliedModalFilters({ type: allTypes, topic: allTopics, skill: allSkills });
    }
  }, [mainSearchResults, filterModalDlts]);

  const hasPendingChanges = JSON.stringify(modalFilters) !== JSON.stringify(appliedModalFilters);

    return (<>

        <div className='search-banner bg-gray bg-monarch-stone'>
            <Grid bleed="1440" colSizes={{ mobile: 4, tablet: 12, desktop: 12, }} >
                <Row>
                    <Col>
                        {<Helmet>
                            <link
                                // href='https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/css/herobanner.css'
                                href={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === 'QA1' ? '/QA1' : global.config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/css/herobanner.css`}
                                rel='stylesheet'
                                type='text/css'
                            ></link>
                            <script
                                src={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === 'QA1' ? '/QA1' : global.config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/js/herobanner.js`}
                                // src='https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/js/herobanner.js'
                                type='text/javascript'
                                async
                            ></script>
                        </Helmet>}
                        <div
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(htmlEventsData),
                            }}
                        />
                    </Col>
                </Row>
            </Grid>
        </div>
        <Block className="classic-search-results compost-width">
            <div className="search-header">
                <button className="search-back-btn body-lg font-eDS-bold" 
                        onClick={() => {
                             contentClick(
                                    askAiData?.resultsPageTexts?.classicSearchTexts?.csBckBtnText,
                                    window.location.href,
                                    "",
                                    'classic_search_back_button',
                                );
                            handleSwitchToAskAI();
                        }} 
                         role="button" aria-label="Back">
                    <Icon name="left-arrow" size={isMobile ? "medium" : "small"} />                     
                     {askAiData?.resultsPageTexts?.classicSearchTexts?.csBckBtnText}
                </button>

                <div className="search-input-wrap">
                    <input
                        placeholder= {askAiData?.resultsPageTexts?.classicSearchTexts?.schBarPchText}
                        type="text"
                        className="search-input body-lg"
                        value={inputValue}
                        ref={inputRef}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter' && inputValue.trim()) handleSearch(); }}
                    />
                    <div className='search-input-icons'>
                        <span className="search-input-clear" onClick={() => { 
                             setInputValue(''); if (inputRef.current) inputRef.current.value = ''; }}
                              style={{ cursor: 'pointer' }}
                              onKeyDown={(e) => { 
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    setInputValue(''); 
                                    if (inputRef.current) inputRef.current.value = '';
                                    inputRef.current?.focus(); 
                                }
                                }}
                                style={{ cursor: 'pointer' }}
                                tabIndex={0} 
                                role="button" 
                                aria-label="Clear search">
                            <Icon name="close" size="large" />
                        </span>
                        <span className={`search-input-icon ${!inputValue.trim() ? 'disabled' : ''}`}
                            onClick={() => {if (inputValue.trim()) handleSearch()}} 
                             onKeyDown={(e) => {
                            if ((e.key === 'Enter' || e.key === ' ') && inputValue.trim()) {
                                e.preventDefault();
                                handleSearch();
                            }
                            }}
                            style={{ 
                                cursor: inputValue.trim() ? 'pointer' : 'not-allowed',
                                opacity: inputValue.trim() ? 1 : 1,
                                pointerEvents: inputValue.trim() ? 'auto' : 'none'
                            }}
                            aria-label="Submit search"  
                            tabIndex={inputValue.trim() ? 0 : -1} 
                            role="button">
                            <Icon name="search" size="large" />
                        </span>
                    </div>

                </div>

                <div className="search-header-right">
                    <span className="search-askai-label body-lg font-eDS-bold">{getToggleLabel('askai')}</span>
                    <button
                        type="button"
                        className="search-askai-toggle"
                        aria-pressed={isAskAiEnabled}
                        onClick={() => {
                             contentClick(
                                isAskAiEnabled ? (getToggleLabel('search') || 'Search') : (getToggleLabel('askai') || 'Ask AI'), 
                                window.location.href,
                                '',
                                'askai_toggle_switch'
                                );
                                handleSwitchToAskAI();
                            }}
                    >
                        <span
                            className={`search-askai-toggle-slider ${isAskAiEnabled ? 'search-askai-toggle-slider-active' : ''
                                }`}
                        />

                        <span className="search-askai-toggle-segment">
                            {/* <Icon
                                name="generative-ai"
                                size={isAskAiEnabled ? 'small' : 'medium'}
                                color={isAskAiEnabled ? "#000000" : "#FFFFFF"}
                            /> */}
                             {isAskAiEnabled ?
                                <img  src={askAiData?.resultsPageTexts?.toggleData[0]?.toggleImg}
                                    alt="AI Beta Icon"  width='16' height='16' />
                                    :
                                <img  src={askAiData?.resultsPageTexts?.toggleData[0]?.toggleImgWhite}
                                    alt="AI Beta Icon" width='20' height='20' />
                            }
                           
                        </span>

                        <span className="search-askai-toggle-segment"
                        style={!isAskAiEnabled ? { position: 'relative', left: '1px' } : {}}>
                            {/* <Icon
                                name="search"
                                size={isAskAiEnabled ? 'small' : 'medium'}
                                color={isAskAiEnabled ? "#FFFFFF" : "#000000"}
                            /> */}
                             {isAskAiEnabled ?
                                <img  src={askAiData?.resultsPageTexts?.toggleData[1]?.toggleImgWhite}
                                    alt="AI Beta Icon" width='20' height='20' />
                                    :
                                <img  src={askAiData?.resultsPageTexts?.toggleData[1]?.toggleImg}
                                    alt="AI Beta Icon"  width='16' height='16' />
                            }
                            
                        </span>
                    </button>
                    <span className="search-submit-btn body-lg font-eDS-bold">{getToggleLabel('search')}</span>
                </div>
            </div>
             {isLoading ? ( 
                <Loader fullscreen={false} active={true} surface="light" />
            ) : mainSearchResults.length > 0 ? (
                <>
                {apiTotalCount > 0 && (
                    <h2 className="search-results-title vds-title-md mobile-vds-title-sm font-eDS-bold">
                    {askAiData?.resultsPageTexts?.classicSearchTexts?.resSummaryTxt?.replace("[amount of results]", apiTotalCount)?.replace("[search query]",  `“${currentQueryNew}”`)}</h2>
                )}
                <Flex className="search-results-toolbar">
                    {apiTotalCount > 0 && (
                        <Flex className="search-results-filters">
                            {visibleFilters.map(filter => {
                                const isActive = activeFilters.includes(filter.key);
                                return  (
                                <button
                                    key={filter.key}
                                    className={`filter-tab  vds-body-sm font-eTX-bold ${activeFilters.includes(filter.key) ? 'filter-tab-active' : ''}`}
                                    onClick={() => handleFilterClick(filter.key)}
                                    aria-pressed={isActive}
                                    aria-label={isActive ? `selected ${filter?.filPillLbl}` : `unselected ${filter?.filPillLbl}`}
                                >
                                    {filter?.filPillLbl}
                                </button>
                             );
                    })}
                        </Flex>
                    )}
                    <Flex className="search-results-icons">
                        <ButtonIcon
                            kind="lowContrast"
                            size={isMobile || isTablet ? "small" : "large"}
                            ariaLabel="Filter"
                            onClick={() => setShowFilterModal(true)}
                            renderIcon={(props) => <Icon name="filter" {...props} />}
                        />
                        {(!activeFilters.includes('all') || appliedModalFilters.type.length === 0 || appliedModalFilters.topic.length === 0 || appliedModalFilters.skill.length === 0) && (
                            <span className="filter-active-badge" />
                        )}
                        {apiTotalCount > 0 && (
                            <ButtonIcon
                                kind="lowContrast"
                                size={isMobile || isTablet ? "small" : "large"}
                                ariaLabel="Sort"
                                onClick={() => setShowSortModal(true)}
                                renderIcon={(props) => <Icon name="sort" {...props} />}
                            />
                        )}
                    </Flex>
                </Flex>
                
            {apiTotalCount > 0 ? (
              <>
                {isMobile ? (
                    <div className="search-results-mobile">
                        {searchResults.slice(0, 12).map(item => (
                            <AiMobileSearchCard
                                key={item.id}
                                item={item}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="search-results-content">
                        <GridWrapper className="search-results-grid">
                            {(isTablet ? searchResults.slice(0, 12) : searchResults).map(item => (
                                // <div key={item.id} className="search-result-card">

                                //     {/* image-icons overlay — same as CourseCards */}
                                //     <div className="image-icons width-fill-avilable">
                                //         {/* {item.recommended && (
                                //             <span className="search-result-badge body-sm font-eTX-bold ">Recommended</span>
                                //         )} */}
                                //         <span className="ml-auto">
                                //             {/* <Favorite
                                //                 courseId={item.id}
                                //                 label={item.title}
                                //                 format={item.type}
                                //                 iconSize="small"
                                //                 contentCategory="search_favorite"
                                //             /> */}
                                //         </span>
                                //     </div>

                                //     {/* image — same as CourseCards */}
                                //     <div className="image">
                                //         <img src={item.thumbnail} alt="" />
                                //     </div>

                                //     {/* description — same as CourseCards */}
                                //     <div className="search-description pa-4X">
                                //         <div className="label wrapWord mb-3X">
                                //             <div className="course-label">
                                //                 <span className="micro font-eTX-bold">{item.type}</span>
                                //                 {item.provider && <span className="dot-wrap"></span>}
                                //                 {item.provider && <span className='micro'>{item.provider}</span>}
                                //             </div>
                                //         </div>

                                //         <div className="title-label  label mb-3X">
                                //             <h3 className="search-result-title title-md">{item.title}</h3>
                                //         </div>

                                //         <div className="durations mt-auto">
                                //             <div className="textarea">
                                //                 <div className="duration-text">
                                //                     <Icon name="timer" size="small" color="#716F6D" />
                                //                     <span className="ml-1X micro font-eTX-bold ">{item.duration}</span>
                                //                 </div>
                                //                 <div>
                                //                     <ButtonIcon
                                //                         kind="ghost"
                                //                         size="medium"
                                //                         ariaLabel={`View ${item.title}`}
                                //                         renderIcon={(props) => <Icon name="right-arrow" {...props} />}
                                //                     />
                                //                 </div>
                                //             </div>
                                //         </div>
                                //     </div>
                                // </div>
                                <SearchResultItemCard key={item.id} item={item} />
                            ))}
                        </GridWrapper>
                    </div>
                )}
                {apiTotalCount > PAGE_SIZE  && (
                    <div className='u-flex search-results-pagination'>
                        <Pagination
                        selectPage={(page) => {handlePagination(page) }}
                        total={Math.ceil(apiTotalCount / PAGE_SIZE)}
                        selectedPage={resetPagination ? 1 : currentPage}
                        showArrow={true}
                        />
                    </div>
                )}
            </>
            ) : <NullScreenResults askAiData={askAiData} currentQueryNew={currentQueryNew}></NullScreenResults>}
         </>
        ) : (
          <NullScreenResults askAiData={askAiData} currentQueryNew={currentQueryNew} />
        )}

        {isLoading ?  
          <Loader fullscreen={false} active={true} surface="light" />
          :
          <AiTopics apiTotalCount={apiTotalCount} currentQueryNew={currentQueryNew} askAiData={askAiData} topics={uniqueTopics} fetchedResults={fetchedResults} ></AiTopics>
        }  
          {/* <NullScreenResults></NullScreenResults> */}
        </Block>
        {showSortModal && (
            <ModalOverlay onClick={handleCloseSortModal}>
                <ModalCard id="sort-modal-card"
                    role="dialog" 
                    aria-modal="true" 
                    aria-labelledby="sort-modal-title"
                    onClick={(e) => e.stopPropagation()}>
                    <ModalCloseButton
                        id="sort-close-btn"
                        type="button"
                        onClick={handleCloseSortModal}
                        aria-label="Close"
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L15 15M15 1L1 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    </ModalCloseButton>

                    <h2 className="title-md mobile-vds-title-sm font-eDS-bold">
                        {askAiData?.resultsPageTexts?.classicSearchTexts?.sortbyLbl}
                    </h2>

                    <div className="sort-modal-options mt-8X ">
                         {sortbyData?.map((sortItem) => {
                        const isChecked = tempSortType === sortItem.sortKey;
                        return (
                            <label className="sort-modal-option" key={sortItem.sortKey} htmlFor={`sort-${sortItem.sortKey}`}>
                                <input type="radio" name="sortResults"
                                id={`sort-${sortItem.sortKey}`}
                                value={sortItem.sortKey} 
                                checked={tempSortType === sortItem.sortKey}
                                onChange={() => setTempSortType(sortItem.sortKey)} 
                                aria-label={`${isChecked ? 'selected' : 'unselected'} ${sortItem.sortLbl}`}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        e.currentTarget.click();
                                    }
                                    }}/>
                                <span className="vds-body-lg" aria-hidden="true">{sortItem.sortLbl}</span>
                            </label>
                          )
                        })}
                    </div>

                    <AskAICtaPrimaryButton
                        type="button"
                        onClick={() => {
                        setSortType(tempSortType); 
                        setResetPagination(true); 
                        setCurrentPage(1);
                        setShowSortModal(false)}
                        }
                        className="sort-modal-submit"
                    >
                        <span className="vds-body-sm font-eTX-bold">{askAiData?.resultsPageTexts?.classicSearchTexts?.sortByBtnLbl}</span>
                    </AskAICtaPrimaryButton>
                </ModalCard>
            </ModalOverlay>
        )}
        {showFilterModal && (
            <ModalOverlay onClick={handleCloseFilterModal}>
                <ModalCard className="filter-modal-card" onClick={(e) => e.stopPropagation()}
                     id="filter-modal-card"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="filter-modal-title">
                    <ModalCloseButton
                        id="filter-close-btn"
                        type="button"
                        onClick={handleCloseFilterModal}
                        aria-label='Close filter modal'
                        
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L15 15M15 1L1 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    </ModalCloseButton>

                    <div className="vds-title-sm font-eDS-bold">
                        {askAiData?.resultsPageTexts?.classicSearchTexts?.filterDlts?.filterlabel}
                    </div>

                    <div className="filter-modal-content mt-8X">
                       {filterModalDlts.map((section, index) => {
                            // 1. Avoid Status Section entirely
                            if (section.category === 'Status') return null;

                            // 2. Map Type Section dynamically
                            if (section.category === 'Type') {
                            return (
                                <div className='filter-modal-section' key={`section-type-${index}`}>
                                <div
                                    className='filter-modal-section-header'
                                     role="button" 
                                    tabIndex={0} 
                                    aria-expanded={expandedSections.type}
                                    onClick={() => toggleSection('type')}
                                     onKeyDown={(e) => {
                                        // [A11Y_FIX] Keyboard support for accordions
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            toggleSection('type');
                                        }
                                        }}
                                >
                                    <div className='filter-modal-section-title vds-title-xs'>
                                    {section.label || 'Type'}
                                    </div>
                                    <div
                                    className={`filter-modal-section-chevron ${expandedSections.type ? 'expanded' : ''}`}
                                    >
                                    <Icon name='up-caret' size='large' />
                                    </div>
                                </div>
                                {expandedSections.type && (
                                    <div className='filter-modal-options'>
                                    {section.subCategory?.[0]?.options?.map((opt, i) =>  {
                                        const isChecked = modalFilters.type.includes(opt.value);
                                        return (
                                        <label key={`type-opt-${i}`} className='filter-modal-option'>
                                        <input  id={`filter-type-${i}`} type='checkbox' name='filterType' value={opt.value} 
                                        checked={modalFilters.type.includes(opt.value)}
                                        onChange={(e) => handleCheckboxChange('type', opt.value, e.target.checked)}  aria-label={`${isChecked ? 'selected' : 'unselected'} ${opt.children}`}
                                        onKeyDown={(e) => {
                                            // [A11Y_FIX] Native click trigger
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                e.currentTarget.click();
                                            }
                                            }} />
                                        <span className='vds-body-lg' aria-hidden="true">{opt.children}</span>
                                        </label>
                                     )})}
                                    </div>
                                )}
                                </div>
                            );
                            }

                            // 3. Map Topic Section dynamically (combining "View all" with renderableTopics)
                            if (section.category === 'Topic') {
                                 const isViewAllChecked = modalFilters.topic.includes('View all');
                            return (
                                <div className='filter-modal-section' key={`section-topic-${index}`}>
                                <div
                                    className='filter-modal-section-header'
                                     role="button" /* [A11Y_FIX] */
                                     tabIndex={0} /* [A11Y_FIX] */
                                    aria-expanded={expandedSections.topic} /* [A11Y_FIX] */
                                    onClick={() => toggleSection('topic')}
                                    onKeyDown={(e) => {
                                    // [A11Y_FIX] Keyboard support for accordions
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        toggleSection('topic');
                                    }
                                    }}
                                >
                                    <div className='filter-modal-section-title vds-title-xs'>
                                    {section.label || 'Topic'}
                                    </div>
                                    <div
                                    className={`filter-modal-section-chevron ${expandedSections.topic ? 'expanded' : ''}`}
                                    >
                                    <Icon name='up-caret' size='large' />
                                    </div>
                                </div>
                                {expandedSections.topic && (
                                    <div className='filter-modal-options'>
                                    <label className="filter-modal-option" htmlFor="filter-topic-viewall">
                                        <input id="filter-topic-viewall" type="checkbox" name="filterTopic" value="View all" 
                                        checked={modalFilters.topic.includes('View all')}
                                        onChange={(e) => handleCheckboxChange('topic', 'View all', e.target.checked)} 
                                         tabIndex={0}
                                        aria-label={`${isViewAllChecked ? 'selected' : 'unselected'} ${askAiData?.resultsPageTexts?.classicSearchTexts?.filterDlts?.viewalltxt}`}
                                        onChange={(e) => handleCheckboxChange('topic', 'View all', e.target.checked)}
                                        onKeyDown={(e) => {
                                            // [A11Y_FIX]
                                            if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            e.currentTarget.click();
                                            }
                                        }} />
                                        <span className="vds-body-lg" aria-hidden="true"> {askAiData?.resultsPageTexts?.classicSearchTexts?.filterDlts?.viewalltxt}</span>
                                    </label>
                                    {renderableTopics.map((topic) => {
                                        const isChecked = modalFilters.topic.includes(topic.id);
                                        return(
                                        <label key={topic.id} className="filter-modal-option" htmlFor={`filter-topic-${topic.id}`}>
                                        <input id={`filter-topic-${topic.id}`} type="checkbox" name="filterTopic" value={topic.id} 
                                        tabIndex={0} 
                                        checked={modalFilters.topic.includes(topic.id)}
                                        aria-label={`${isChecked ? 'selected' : 'unselected'} ${topic.title}`}
                                        onChange={(e) => handleCheckboxChange('topic', topic.id, e.target.checked)} 
                                        onKeyDown={(e) => {
                                            // [A11Y_FIX]
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                e.currentTarget.click();
                                            }
                                            }}/>
                                        <span className="vds-body-lg" aria-hidden="true">{topic.title}</span>
                                        </label>
                                     )})}
                                    </div>
                                )}
                                </div>
                            );
                            }

                            // 4. Map Skill Level Section dynamically
                            if (section.category === 'Skill level') {
                            return (
                                <div className="filter-modal-section" key={`section-skill-${index}`}>
                                <div
                                    className="filter-modal-section-header"
                                     role="button" /* [A11Y_FIX] */
                                    tabIndex={0}
                                    aria-expanded={expandedSections.skilllevel}
                                    onKeyDown={(e) => {
                                    // [A11Y_FIX] Keyboard support for accordions
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        toggleSection('skilllevel');
                                    }
                                    }}
                                    onClick={() => toggleSection('skilllevel')}
                                >
                                    <div className="filter-modal-section-title vds-title-xs">
                                    {section.filterLbl || section.label || 'Skill level'}
                                    </div>
                                    <div className={`filter-modal-section-chevron ${expandedSections.skilllevel ? 'expanded' : ''}`}>
                                    <Icon name="up-caret" size="large" />
                                    </div>
                                </div>
                                {expandedSections.skilllevel && (
                                    <div className="filter-modal-options">
                                    {/* Filtering out "All" if JSON gives both "View all" and "All" */}
                                    {section.details?.filter((opt) => opt.skillName !== 'All').map((opt, i) => {
                                        const isChecked = modalFilters.skill.includes(opt.key);
                                        return (
                                        <label key={`skill-opt-${i}`} className="filter-modal-option">
                                        <input id={`filter-skill-${i}`}  type="checkbox" name="filterSkill" value={opt.key} 
                                        checked={modalFilters.skill.includes(opt.key)}
                                         tabIndex={0}
                                        aria-label={`${isChecked ? 'selected' : 'unselected'} ${opt.skillName}`}
                                        onChange={(e) => handleCheckboxChange('skill', opt.key, e.target.checked)}
                                        onKeyDown={(e) => {
                                            // [A11Y_FIX]
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                e.currentTarget.click();
                                            }
                                            }} />
                                        <span className="vds-body-lg" aria-hidden="true">{opt.skillName}</span>
                                        </label>
                                     )})}
                                    </div>
                                )}
                                </div>
                            );
                            }

                            return null;
                        })}
                    </div>

                    <div className="filter-modal-footer">
                        <div className="filter-modal-actions">
                            <button
                                type="button"
                                disabled={!hasPendingChanges}
                                onClick={handleApplyModalFilters}
                                className={`filter-modal-action-btn filter-modal-action-btn-primary vds-body-sm font-eTX-bold ${hasPendingChanges ? 'active' : ''}`}>
                                {askAiData?.resultsPageTexts?.classicSearchTexts?.filterDlts?.viewresultstxt}
                            </button>
                            <button
                                type="button"
                                onClick={handleClearAllFilters}
                                className="filter-modal-action-btn filter-modal-action-btn-secondary vds-body-sm font-eTX-bold"
                            >
                                {askAiData?.resultsPageTexts?.classicSearchTexts?.filterDlts?.clearalltxt}
                            </button>
                        </div>
                    </div>
                </ModalCard>
            </ModalOverlay>
        )}

    </>
    )
}

export default SearchResultsComponent;